import { Inertia, Method } from '@inertiajs/inertia'
import { FunctionalComponent, h } from '@stencil/core'
import { JSXBase } from '@stencil/core/internal'
import { noop } from 'lodash-es'

import { classes } from '../../utils/css'

type LinkProps = Partial<{
  data: any
  href: string
  activeClass: string
  exactMatch: boolean
  nonMatchingUrls: string[]
  method: Method
  preserveScroll: boolean
  preserveState: boolean
  replace: boolean
}>

// Track special keys for when links are clicked
let openInTab = false
document.body.addEventListener('keydown', (e) => (openInTab = e.ctrlKey || e.metaKey))
document.body.addEventListener('keyup', () => (openInTab = false))

export const InertiaLink: FunctionalComponent<LinkProps & JSXBase.IntrinsicElements['a']> = (
  {
    data = {},
    href = '',
    method = 'get' as Method,
    preserveScroll = false,
    preserveState = false,
    replace = false,
    onClick = noop,
    class: className = '',
    activeClass,
    exactMatch,
    nonMatchingUrls = [],
    ...props
  } = {},
  children
) => {
  const url = new URL(href, location.origin)
  let isActive = false
  if (href && onClick === noop) {
    if (exactMatch) {
      isActive = location.href === url.href
    } else {
      isActive = !nonMatchingUrls.includes(location.pathname) && location.href.startsWith(url.href)
    }
  }
  return (
    <a
      class={`${className} ${classes(isActive && activeClass, `${activeClass}`)} ${classes(!!href, 'cursor-pointer')}`}
      {...props}
      {...(href && { href: href })}
      onClick={(e) => {
        onClick(e)
        if (e.which === 2 || openInTab || props.target || !href) {
          // Allow middle button, command (Mac) & control (Win) clicks to open
          // a link in a new tab, instead of letting Inertia handle it
          return
        }
        e.preventDefault()
        Inertia.visit(href, {
          data,
          method,
          preserveScroll,
          preserveState,
          replace,
        })
      }}
    >
      {children}
    </a>
  )
}
